import { jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import NeedsBasedQuestions from "./NeedsBasedQuestions/NeedsBasedQuestions.js";
function resolveInitialState(parentQuestions) {
  const result = {};
  parentQuestions.forEach((question) => {
    result[question.questionId] = question.answer.__typename === "MultiChoiceMultiAnswer" ? [] : "";
  });
  return result;
}
function Questionnaire({
  questionnaireQuestions,
  QuestionComponent,
  ScriptingContainer,
  onAnswersUpdated,
  answersInitialState,
  hasError = false
}) {
  const parentQuestions = (questionnaireQuestions == null ? void 0 : questionnaireQuestions.filter((question) => {
    var _a;
    return ((_a = question.triggers) == null ? void 0 : _a.length) === 0 || question.triggers === null;
  })) || [];
  const [nbqAnswers, setNbqAnswers] = useState(answersInitialState ?? resolveInitialState(parentQuestions));
  useEffect(() => {
    onAnswersUpdated(nbqAnswers);
  }, [nbqAnswers, onAnswersUpdated]);
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
    NeedsBasedQuestions,
    {
      updateAnswers: setNbqAnswers,
      answers: nbqAnswers,
      needsBasedQuestionsAPI: questionnaireQuestions,
      QuestionComponent,
      ScriptingContainer,
      hasError
    }
  ) });
}
export {
  Questionnaire as default
};
